<div
  class="display-flex"
  [ngClass]="{'m-t-15 m-b-15': addMargin}">
  <div class="flex-1">
    <lib-form-control
      [label]="uploadLabel"
      variant="text"
      placeholder
      controlName="rutaArchivo"
      [formGroupParent]="form"
      [disabled]="true">
    </lib-form-control>
    <input
      #inputFile
      class="file-input"
      type="file"
      (change)="handleChangeFile($event)">
  </div>
  <button
    *ngIf="!selectedFile"
    class="button-attach-file"
    mat-stroked-button
    [matTooltip]="attachText"
    color="primary"
    type="button"
    (click)="handleAttachFile()"
    [disabled]="disabled">
    <mat-icon>attach_file</mat-icon>
    <span *ngIf="!hideAttachText">{{attachText}}</span>
  </button>
  <button
    *ngIf="selectedFile"
    class="button-attach-file"
    mat-stroked-button
    [matTooltip]="'Quitar archivo'"
    type="button"
    color="primary"
    (click)="handleDeleteFile()"
    [disabled]="disabled">
    <mat-icon>delete</mat-icon>
    <!-- Quitar archivo -->
  </button>
</div>
